import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SymbolRedLoading from "../../../../images/equinor-symbol-red-loading.gif";
import SymbolWhiteLoading from "../../../../images/equinor-symbol-white-loading.gif";

export const FullScreenLoading: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.grey[800]
            : theme.palette.grey[100],
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        left: 0,
        minHeight: "100vh",
        minWidth: "100vw",
        position: "fixed",
        top: 0,
        zIndex: 2000,
      }}
    >
      <img
        alt="Loading..."
        src={
          theme.palette.mode === "dark" ? SymbolWhiteLoading : SymbolRedLoading
        }
        style={{ height: "100px", margin: "1.5rem" }}
      />

      <h1 style={{ fontSize: "36px" }}>{t("pageLoading.title")}</h1>

      <h3>{t("pageLoading.message")}</h3>
    </Box>
  );
};
